import themes from '@nab/nui-themes-web';
import { defaultThemeName } from '../../foundation/Theme';
var themesTypes = Object.keys(themes);
/**
 * @param {string} themeName
 * @return string
 */

export var validateThemeName = function validateThemeName(themeName) {
  if (themesTypes.includes(themeName)) {
    return themeName;
  }

  console.warn("Theme name \"".concat(themeName, "\" is not supported in this version of nuit. Supported themes are ").concat(themesTypes));
  return defaultThemeName;
};